import React from "react";
import { Paper, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import LandingImage from "./landingCompnents/LandingImage";
import LandingHeader from "./landingCompnents/LandingHeader";
import { typeWriterData } from "../data/";
import "../static/css/landingCss.css";
import { titleImg } from "../static/images/titleImage";

const useStyle = makeStyles((theme) => ({
  mainDiv: {
    height: "100vh",
  },
  mainPaper: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "spaceBetween",
  },
}));
const Landing = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyle();
  const phraseOne = "Creating a";
  const phraseTwo = "Community";
  return (
    <>
      <div className={classes.mainDiv}>
        <Paper className={classes.mainPaper} elevation="0">
          <div className="textDiv">
            <LandingHeader
              phraseOne={phraseOne}
              phraseTwo={phraseTwo}
              typeWriterData={typeWriterData}
            />
          </div>
          {isMobile ? null : (
            <div className="imageDiv">
              <LandingImage titleImg={titleImg} />
            </div>
          )}
        </Paper>
      </div>
    </>
  );
};

export default Landing;
